import { atom } from 'jotai';

// Number of open mobile bottom sheets (upsell product modal, cart-details
// drawer, quantity sheet). When > 0 the Layout locks the background checkout
// scroll so touch-scroll stays inside the sheet instead of bleeding to the
// page behind it.
export const bottomSheetOpenCountAtom = atom<number>(0);
